/**
 * @generated SignedSource<<f2a8df31c37438f57db8085976cd8dc4>>
 * @relayHash b8e87dbf49a11866a3cab28b7a684e8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd88bdfcd43fa366fbdcbe89d654db93fd30d591bc0f038b7733d40959af80ed

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AggGoalTabContentQuery$variables = {
  containerId: string;
  goalKey: string;
  includeDraftUpdate: boolean;
  isDecisionsTab: boolean;
  isJiraAlignTab: boolean;
  isJiraTab: boolean;
  isLearningsTab: boolean;
  isProjectsTab: boolean;
  isRisksTab: boolean;
  isUpdatesTab: boolean;
  queryContext?: string | null;
};
export type AggGoalTabContentQuery$data = {
  readonly goals_byKey: {
    readonly " $fragmentSpreads": FragmentRefs<"AggGoalUpdatesTabContent" | "GoalContentAbout" | "GoalContentDecisions" | "GoalContentJira" | "GoalContentJiraAlign" | "GoalContentLearnings" | "GoalContentProjects" | "GoalContentRisks">;
  } | null;
};
export type AggGoalTabContentQuery = {
  response: AggGoalTabContentQuery$data;
  variables: AggGoalTabContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "goalKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraftUpdate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDecisionsTab"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraAlignTab"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraTab"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLearningsTab"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectsTab"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRisksTab"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isUpdatesTab"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v11 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "goalKey",
    "variableName": "goalKey"
  }
],
v12 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "ScalarField",
  "name": "description"
},
v16 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v17 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v18 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v19 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v20 = {
  "kind": "ScalarField",
  "name": "kind"
},
v21 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v22 = {
  "kind": "ScalarField",
  "name": "value"
},
v23 = [
  (v22/*: any*/)
],
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v25 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v24/*: any*/)
  ]
},
v26 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v23/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v24/*: any*/)
  ]
},
v27 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v28 = {
  "kind": "ScalarField",
  "name": "archived"
},
v29 = {
  "kind": "ScalarField",
  "name": "key"
},
v30 = {
  "kind": "ScalarField",
  "name": "name"
},
v31 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v32 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v33 = {
  "kind": "ScalarField",
  "name": "start"
},
v34 = {
  "kind": "ScalarField",
  "name": "end"
},
v35 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v33/*: any*/),
    (v34/*: any*/)
  ]
},
v36 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v32/*: any*/),
    (v35/*: any*/)
  ]
},
v37 = [
  (v22/*: any*/),
  (v14/*: any*/)
],
v38 = {
  "kind": "ScalarField",
  "name": "variance"
},
v39 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v37/*: any*/)
    },
    (v38/*: any*/)
  ]
},
v40 = {
  "kind": "ScalarField",
  "name": "type"
},
v41 = {
  "kind": "ScalarField",
  "name": "subType"
},
v42 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v43 = [
  (v42/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v44 = {
  "kind": "ScalarField",
  "name": "time"
},
v45 = {
  "kind": "ScalarField",
  "name": "picture"
},
v46 = [
  (v21/*: any*/),
  (v30/*: any*/),
  (v45/*: any*/),
  (v14/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v48 = [
  (v14/*: any*/)
],
v49 = {
  "kind": "ScalarField",
  "name": "score"
},
v50 = [
  (v22/*: any*/),
  (v49/*: any*/)
],
v51 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v50/*: any*/)
},
v52 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v53 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v54 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v55 = {
  "args": (v43/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v22/*: any*/),
            (v44/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v46/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v47/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v48/*: any*/)
                        },
                        (v51/*: any*/),
                        (v14/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v47/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v52/*: any*/),
            (v21/*: any*/)
          ]
        },
        (v53/*: any*/)
      ]
    },
    (v54/*: any*/),
    (v52/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v56 = {
  "args": (v43/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v57 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v58 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v37/*: any*/)
},
v59 = [
  (v44/*: any*/),
  (v14/*: any*/)
],
v60 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v34/*: any*/)
  ]
},
v61 = {
  "args": (v43/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v59/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                (v60/*: any*/)
              ]
            },
            (v22/*: any*/)
          ]
        },
        (v38/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v62 = {
  "kind": "ScalarField",
  "name": "url"
},
v63 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v50/*: any*/)
},
v64 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v65 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareTargetDateRange",
      "kind": "LinkedField",
      "name": "dateRange",
      "plural": false,
      "selections": [
        (v34/*: any*/),
        (v33/*: any*/)
      ]
    }
  ]
},
v66 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v67 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v68 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v69 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v70 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v21/*: any*/),
                (v30/*: any*/),
                (v14/*: any*/),
                (v68/*: any*/),
                (v45/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v69/*: any*/),
            (v47/*: any*/)
          ]
        }
      ]
    },
    (v52/*: any*/)
  ]
},
v71 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v72 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v73 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v74 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v75 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v74/*: any*/)
  ]
},
v76 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v29/*: any*/)
  ]
},
v77 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v26/*: any*/),
    (v76/*: any*/),
    (v14/*: any*/)
  ]
},
v78 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v79 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v80 = {
  "kind": "ScalarField",
  "name": "summary"
},
v81 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v78/*: any*/),
            (v79/*: any*/),
            (v80/*: any*/),
            (v69/*: any*/),
            (v47/*: any*/),
            (v14/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v82 = {
  "concreteType": "TownsquareUserConnection",
  "kind": "LinkedField",
  "name": "watchers",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "count"
    }
  ]
},
v83 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v84 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v85 = [
  (v21/*: any*/),
  (v45/*: any*/),
  (v30/*: any*/),
  (v68/*: any*/),
  (v14/*: any*/)
],
v86 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v85/*: any*/)
},
v87 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v85/*: any*/)
},
v88 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v89 = {
  "kind": "ScalarField",
  "name": "source"
},
v90 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v59/*: any*/)
},
v91 = [
  (v22/*: any*/),
  (v44/*: any*/),
  (v14/*: any*/)
],
v92 = [
  (v40/*: any*/),
  (v74/*: any*/)
],
v93 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v92/*: any*/)
},
v94 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v74/*: any*/),
    (v40/*: any*/)
  ]
},
v95 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v14/*: any*/),
                (v30/*: any*/),
                (v40/*: any*/),
                (v41/*: any*/),
                (v28/*: any*/),
                (v72/*: any*/),
                (v89/*: any*/),
                (v90/*: any*/)
              ]
            },
            (v58/*: any*/),
            (v31/*: any*/),
            (v57/*: any*/)
          ]
        }
      ]
    }
  ]
},
v96 = [
  (v35/*: any*/)
],
v97 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v96/*: any*/)
},
v98 = [
  (v21/*: any*/),
  (v68/*: any*/),
  (v30/*: any*/),
  (v45/*: any*/),
  (v14/*: any*/)
],
v99 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v98/*: any*/)
},
v100 = {
  "kind": "ScalarField",
  "name": "label"
},
v101 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v98/*: any*/)
},
v102 = [
  (v47/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v22/*: any*/),
      (v49/*: any*/),
      (v100/*: any*/)
    ]
  },
  (v80/*: any*/),
  (v101/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v80/*: any*/),
              (v15/*: any*/),
              (v28/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              (v14/*: any*/),
              (v80/*: any*/),
              (v15/*: any*/),
              (v84/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              (v47/*: any*/),
              (v88/*: any*/)
            ]
          }
        ]
      },
      (v52/*: any*/)
    ]
  },
  (v14/*: any*/)
],
v103 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v102/*: any*/)
},
v104 = [
  (v100/*: any*/),
  (v35/*: any*/)
],
v105 = {
  "kind": "ScalarField",
  "name": "canEditUpdates"
},
v106 = {
  "kind": "ScalarField",
  "name": "canDeleteUpdates"
},
v107 = {
  "kind": "InlineFragment",
  "selections": (v48/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v108 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v109 = [
  (v108/*: any*/),
  (v12/*: any*/)
],
v110 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v80/*: any*/),
      (v15/*: any*/),
      (v86/*: any*/),
      (v87/*: any*/),
      (v47/*: any*/),
      (v88/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v111 = {
  "concreteType": "TownsquareGoalCapabilities",
  "kind": "LinkedField",
  "name": "capabilities",
  "plural": false,
  "selections": [
    (v106/*: any*/),
    (v105/*: any*/)
  ]
},
v112 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v113 = [
  (v108/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v114 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v23/*: any*/)
},
v115 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v21/*: any*/),
    (v14/*: any*/),
    (v30/*: any*/),
    (v45/*: any*/),
    (v68/*: any*/)
  ]
},
v116 = [
  (v21/*: any*/),
  (v14/*: any*/)
],
v117 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v116/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v116/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v118 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v119 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v96/*: any*/)
},
v120 = {
  "args": (v113/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "GoalContentAbout"
          },
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "includeDraftUpdate",
                    "variableName": "includeDraftUpdate"
                  }
                ],
                "kind": "FragmentSpread",
                "name": "AggGoalUpdatesTabContent"
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v13/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJiraAlign"
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v13/*: any*/),
                "kind": "FragmentSpread",
                "name": "GoalContentJira"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentLearnings"
              }
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentRisks"
              }
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentDecisions"
              }
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "GoalContentProjects"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Operation",
    "name": "AggGoalTabContentQuery",
    "selections": [
      {
        "args": (v11/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byKey",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              (v16/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v18/*: any*/)
                ]
              },
              (v19/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v14/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/)
                ]
              },
              (v14/*: any*/),
              (v25/*: any*/)
            ]
          },
          {
            "args": (v27/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      (v14/*: any*/),
                      {
                        "concreteType": "TownsquareGoalIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v29/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      (v30/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v36/*: any*/),
                                              (v22/*: any*/),
                                              (v39/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v14/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v30/*: any*/),
                                      (v14/*: any*/),
                                      (v55/*: any*/),
                                      (v56/*: any*/)
                                    ]
                                  },
                                  (v57/*: any*/),
                                  (v58/*: any*/),
                                  (v61/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v29/*: any*/),
                      (v62/*: any*/),
                      (v63/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v45/*: any*/),
                          (v30/*: any*/),
                          (v14/*: any*/)
                        ]
                      },
                      (v64/*: any*/),
                      (v65/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v19/*: any*/),
                          (v16/*: any*/),
                          {
                            "concreteType": "TownsquareGoalAppCapabilities",
                            "kind": "LinkedField",
                            "name": "apps",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v47/*: any*/)
                    ]
                  },
                  (v21/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          (v70/*: any*/),
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v71/*: any*/),
              (v14/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v21/*: any*/),
                      (v14/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v30/*: any*/),
                          (v40/*: any*/),
                          (v41/*: any*/),
                          (v28/*: any*/),
                          (v72/*: any*/),
                          (v52/*: any*/),
                          (v55/*: any*/),
                          (v56/*: any*/)
                        ]
                      },
                      (v58/*: any*/),
                      (v31/*: any*/),
                      (v57/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v36/*: any*/),
                                  (v22/*: any*/),
                                  (v39/*: any*/),
                                  (v21/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v61/*: any*/)
                    ]
                  }
                ]
              },
              (v52/*: any*/)
            ]
          },
          (v66/*: any*/),
          (v67/*: any*/),
          (v47/*: any*/),
          (v65/*: any*/),
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": (v23/*: any*/)
          },
          (v28/*: any*/),
          {
            "concreteType": "TownsquareGoalProgress",
            "kind": "LinkedField",
            "name": "progress",
            "plural": false,
            "selections": [
              (v40/*: any*/)
            ]
          },
          {
            "condition": "isUpdatesTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                  (v49/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "latestUpdateDate"
              },
              (v64/*: any*/),
              {
                "args": (v27/*: any*/),
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "successMeasures",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v71/*: any*/),
                          (v73/*: any*/),
                          (v75/*: any*/),
                          (v77/*: any*/),
                          (v81/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "successMeasures(first:50)"
              },
              {
                "concreteType": "TownsquareTargetDate",
                "kind": "LinkedField",
                "name": "targetDate",
                "plural": false,
                "selections": [
                  (v32/*: any*/)
                ]
              },
              (v82/*: any*/),
              (v75/*: any*/),
              {
                "args": (v83/*: any*/),
                "concreteType": "TownsquareGoalUpdateConnection",
                "kind": "LinkedField",
                "name": "updates",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v80/*: any*/),
                          {
                            "concreteType": "TownsquareUpdateNoteConnection",
                            "kind": "LinkedField",
                            "name": "updateNotes",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNoteEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareUpdateNote",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v80/*: any*/),
                                      (v15/*: any*/),
                                      (v14/*: any*/),
                                      (v28/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v21/*: any*/),
                          (v71/*: any*/),
                          (v47/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "ari"
                          },
                          (v78/*: any*/),
                          (v79/*: any*/),
                          (v51/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDate"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newTargetDateConfidence"
                          },
                          {
                            "concreteType": "TownsquareHighlightConnection",
                            "kind": "LinkedField",
                            "name": "highlights",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareHighlightEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v80/*: any*/),
                                      (v15/*: any*/),
                                      (v21/*: any*/),
                                      (v14/*: any*/),
                                      (v84/*: any*/),
                                      (v86/*: any*/),
                                      (v87/*: any*/),
                                      (v47/*: any*/),
                                      (v88/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v52/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalMetricUpdateConnection",
                            "kind": "LinkedField",
                            "name": "metricUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalMetricUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v30/*: any*/),
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v28/*: any*/),
                                          (v89/*: any*/),
                                          (v90/*: any*/),
                                          {
                                            "args": [
                                              (v42/*: any*/),
                                              {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": [
                                                  "TIME_DESC"
                                                ]
                                              }
                                            ],
                                            "concreteType": "TownsquareMetricValueConnection",
                                            "kind": "LinkedField",
                                            "name": "values",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricValue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v91/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                          }
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "newValue",
                                        "plural": false,
                                        "selections": (v91/*: any*/)
                                      },
                                      {
                                        "concreteType": "TownsquareMetricValue",
                                        "kind": "LinkedField",
                                        "name": "oldValue",
                                        "plural": false,
                                        "selections": [
                                          (v44/*: any*/),
                                          (v14/*: any*/),
                                          (v22/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newStartValue"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "newTargetValue"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetConnection",
                                "kind": "LinkedField",
                                "name": "metricTargets",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTargetEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTarget",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetric",
                                            "kind": "LinkedField",
                                            "name": "metric",
                                            "plural": false,
                                            "selections": [
                                              (v14/*: any*/),
                                              (v28/*: any*/),
                                              (v30/*: any*/),
                                              (v40/*: any*/),
                                              (v41/*: any*/),
                                              (v72/*: any*/),
                                              (v89/*: any*/),
                                              (v90/*: any*/)
                                            ]
                                          },
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodConnection",
                                            "kind": "LinkedField",
                                            "name": "metricTargetPeriods",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriodEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareMetricTargetPeriod",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDate",
                                                        "kind": "LinkedField",
                                                        "name": "date",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "TownsquareTargetDateRange",
                                                            "kind": "LinkedField",
                                                            "name": "dateRange",
                                                            "plural": false,
                                                            "selections": [
                                                              (v33/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v22/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v14/*: any*/),
                                          (v31/*: any*/),
                                          (v57/*: any*/),
                                          (v58/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v14/*: any*/),
                              (v64/*: any*/),
                              (v28/*: any*/),
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "goalType",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalType",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  (v14/*: any*/)
                                ]
                              },
                              (v93/*: any*/),
                              {
                                "args": (v27/*: any*/),
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "successMeasures",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v30/*: any*/),
                                          (v28/*: any*/),
                                          (v94/*: any*/),
                                          (v95/*: any*/),
                                          (v62/*: any*/),
                                          (v64/*: any*/),
                                          (v97/*: any*/),
                                          (v99/*: any*/),
                                          (v103/*: any*/),
                                          (v71/*: any*/),
                                          (v73/*: any*/),
                                          (v77/*: any*/),
                                          (v63/*: any*/),
                                          (v81/*: any*/)
                                        ]
                                      },
                                      (v21/*: any*/)
                                    ]
                                  }
                                ],
                                "storageKey": "successMeasures(first:50)"
                              },
                              {
                                "concreteType": "TownsquareGoalConnection",
                                "kind": "LinkedField",
                                "name": "subGoals",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v30/*: any*/),
                                          (v28/*: any*/),
                                          (v94/*: any*/),
                                          {
                                            "concreteType": "TownsquareGoalType",
                                            "kind": "LinkedField",
                                            "name": "goalType",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v14/*: any*/),
                                              (v76/*: any*/)
                                            ]
                                          },
                                          (v95/*: any*/),
                                          (v62/*: any*/),
                                          (v64/*: any*/),
                                          (v97/*: any*/),
                                          (v99/*: any*/),
                                          (v103/*: any*/),
                                          (v73/*: any*/),
                                          (v63/*: any*/),
                                          (v81/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 10
                                  }
                                ],
                                "concreteType": "TownsquareGoalUpdateConnection",
                                "kind": "LinkedField",
                                "name": "updates",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdateEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareGoalUpdate",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v14/*: any*/),
                                          (v80/*: any*/),
                                          {
                                            "concreteType": "TownsquareUpdateNoteConnection",
                                            "kind": "LinkedField",
                                            "name": "updateNotes",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNoteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareUpdateNote",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v80/*: any*/),
                                                      (v15/*: any*/),
                                                      (v14/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "storageKey": "updates(first:10)"
                              }
                            ]
                          },
                          (v101/*: any*/),
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "newDueDate",
                            "plural": false,
                            "selections": (v104/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "newProgress",
                            "plural": false,
                            "selections": (v92/*: any*/)
                          },
                          {
                            "args": (v27/*: any*/),
                            "concreteType": "TownsquareGoalBundledUpdateConnection",
                            "kind": "LinkedField",
                            "name": "bundledUpdates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalBundledUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "successMeasure",
                                    "plural": false,
                                    "selections": [
                                      (v75/*: any*/),
                                      (v14/*: any*/)
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v102/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "nodeMissingReason"
                                  },
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "goal",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v30/*: any*/),
                                      (v93/*: any*/),
                                      (v95/*: any*/),
                                      (v62/*: any*/),
                                      (v64/*: any*/),
                                      (v97/*: any*/),
                                      (v99/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "bundledUpdates(first:50)"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v68/*: any*/),
                              (v30/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          (v69/*: any*/),
                          {
                            "args": [
                              (v42/*: any*/)
                            ],
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                            "kind": "LinkedField",
                            "name": "viewers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v21/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/),
                                          (v30/*: any*/),
                                          (v68/*: any*/),
                                          (v45/*: any*/)
                                        ],
                                        "type": "AtlassianAccountUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v48/*: any*/),
                                        "type": "AppUser"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v48/*: any*/),
                                        "type": "CustomerUser"
                                      }
                                    ]
                                  },
                                  (v14/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "viewers(first:100)"
                          },
                          (v62/*: any*/),
                          (v70/*: any*/),
                          {
                            "concreteType": "TownsquareGoalState",
                            "kind": "LinkedField",
                            "name": "oldState",
                            "plural": false,
                            "selections": (v50/*: any*/)
                          },
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "oldDueDate",
                            "plural": false,
                            "selections": (v104/*: any*/)
                          }
                        ]
                      },
                      (v53/*: any*/),
                      (v21/*: any*/)
                    ]
                  },
                  (v54/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": "updates(first:20)"
              },
              {
                "args": (v83/*: any*/),
                "handle": "connection",
                "key": "UpdatesList__updates",
                "kind": "LinkedHandle",
                "name": "updates"
              },
              {
                "concreteType": "TownsquareMetricTargetConnection",
                "kind": "LinkedField",
                "name": "metricTargets",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTargetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTarget",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetric",
                            "kind": "LinkedField",
                            "name": "metric",
                            "plural": false,
                            "selections": [
                              (v89/*: any*/),
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "latestValue",
                                "plural": false,
                                "selections": [
                                  (v44/*: any*/),
                                  (v22/*: any*/),
                                  (v14/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoalUpdate",
                "kind": "LinkedField",
                "name": "latestUserUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateConnection",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdateEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "newValue",
                                "plural": false,
                                "selections": (v59/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v14/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v30/*: any*/),
                          (v62/*: any*/),
                          (v73/*: any*/),
                          (v75/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v76/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          (v63/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": (v46/*: any*/)
                          },
                          (v97/*: any*/),
                          (v81/*: any*/),
                          (v64/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canCommentOnUpdates"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canWatchGoal"
                  },
                  (v105/*: any*/),
                  (v106/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "isWatching"
              },
              (v29/*: any*/),
              (v73/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canEditUpdate"
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "updateStreak"
              },
              {
                "condition": "includeDraftUpdate",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalDraftUpdate",
                    "kind": "LinkedField",
                    "name": "latestDraftUpdate",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          (v64/*: any*/),
                          (v63/*: any*/),
                          {
                            "concreteType": "TownsquareTargetDate",
                            "kind": "LinkedField",
                            "name": "targetDate",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v60/*: any*/)
                            ]
                          },
                          (v14/*: any*/),
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v58/*: any*/),
                                      (v31/*: any*/),
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v40/*: any*/),
                                          (v41/*: any*/),
                                          (v14/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v80/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      (v49/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDateInputDraft",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "date"
                          },
                          (v32/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareMetricUpdateInputDraft",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "targetId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "newValue"
                          },
                          (v44/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareUpdateNoteInputDraft",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": true,
                        "selections": [
                          (v80/*: any*/),
                          (v15/*: any*/),
                          (v71/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareUpdateHighlightInputDraft",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": true,
                        "selections": [
                          (v80/*: any*/),
                          (v15/*: any*/),
                          (v40/*: any*/)
                        ]
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "provenance_extension"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": (v46/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "modifiedDate"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraAlignTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v13/*: any*/),
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
                "kind": "LinkedField",
                "name": "jiraAlignItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectName"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "mercuryProjectStatus",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "mercuryName"
                                  },
                                  (v107/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryTargetDateEnd"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "mercuryProjectUrl"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "mercuryProjectOwner",
                                "plural": false,
                                "selections": (v98/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "name": "externalOwner",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "firstName"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "lastName"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAlignAggProject"
                          },
                          (v107/*: any*/)
                        ]
                      },
                      (v14/*: any*/)
                    ]
                  },
                  (v52/*: any*/)
                ]
              },
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddJiraAlignItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveJiraAlignItems"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isJiraTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddLinkedWorkItems"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedWorkItems"
                  }
                ]
              },
              {
                "args": (v109/*: any*/),
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
                "kind": "LinkedField",
                "name": "workItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              (v29/*: any*/),
                              (v80/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v107/*: any*/)
                        ]
                      },
                      (v53/*: any*/),
                      (v14/*: any*/)
                    ]
                  },
                  (v54/*: any*/),
                  (v52/*: any*/)
                ]
              },
              {
                "args": (v109/*: any*/),
                "filters": [
                  "queryContext"
                ],
                "handle": "connection",
                "key": "GoalContentJira_workItems",
                "kind": "LinkedHandle",
                "name": "workItems"
              }
            ]
          },
          {
            "condition": "isLearningsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/),
              (v62/*: any*/),
              (v82/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*: any*/),
                            "type": "TownsquareLearning"
                          }
                        ]
                      }
                    ]
                  },
                  (v52/*: any*/)
                ]
              },
              (v111/*: any*/)
            ]
          },
          {
            "condition": "isRisksTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/),
              (v62/*: any*/),
              (v82/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*: any*/),
                            "type": "TownsquareRisk"
                          }
                        ]
                      }
                    ]
                  },
                  (v52/*: any*/)
                ]
              },
              (v111/*: any*/)
            ]
          },
          {
            "condition": "isDecisionsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v29/*: any*/),
              (v62/*: any*/),
              (v82/*: any*/),
              {
                "concreteType": "TownsquareHighlightConnection",
                "kind": "LinkedField",
                "name": "highlights",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareHighlightEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": (v110/*: any*/),
                            "type": "TownsquareDecision"
                          }
                        ]
                      }
                    ]
                  },
                  (v52/*: any*/)
                ]
              },
              (v111/*: any*/)
            ]
          },
          {
            "condition": "isProjectsTab",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveLinkedProjects"
                  },
                  {
                    "concreteType": "TownsquareGoalAppCapabilities",
                    "kind": "LinkedField",
                    "name": "apps",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ]
                  },
                  (v112/*: any*/)
                ]
              },
              {
                "args": (v113/*: any*/),
                "concreteType": "TownsquareProjectConnection",
                "kind": "LinkedField",
                "name": "projects",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      (v53/*: any*/),
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v14/*: any*/),
                          (v114/*: any*/),
                          (v115/*: any*/),
                          (v117/*: any*/),
                          {
                            "concreteType": "TownsquareProjectUpdate",
                            "kind": "LinkedField",
                            "name": "latestUserUpdate",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectPhaseDetails",
                                "kind": "LinkedField",
                                "name": "newPhase",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": "_id",
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              (v14/*: any*/)
                            ]
                          },
                          (v73/*: any*/),
                          (v30/*: any*/),
                          (v62/*: any*/),
                          (v118/*: any*/),
                          (v119/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v54/*: any*/),
                  (v52/*: any*/)
                ],
                "storageKey": "projects(first:200,tql:\"archived = false\")"
              },
              (v120/*: any*/),
              {
                "concreteType": "TownsquareGoalConnection",
                "kind": "LinkedField",
                "name": "subGoals",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          (v73/*: any*/),
                          (v30/*: any*/),
                          (v63/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              (v76/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          {
                            "args": (v113/*: any*/),
                            "concreteType": "TownsquareProjectConnection",
                            "kind": "LinkedField",
                            "name": "projects",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareProjectEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareProject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v73/*: any*/),
                                      (v30/*: any*/),
                                      (v62/*: any*/),
                                      (v118/*: any*/),
                                      (v114/*: any*/),
                                      (v119/*: any*/),
                                      (v115/*: any*/),
                                      (v21/*: any*/),
                                      (v117/*: any*/)
                                    ]
                                  },
                                  (v53/*: any*/),
                                  (v21/*: any*/)
                                ]
                              },
                              (v54/*: any*/),
                              (v52/*: any*/)
                            ],
                            "storageKey": "projects(first:200,tql:\"archived = false\")"
                          },
                          (v120/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              (v112/*: any*/)
                            ]
                          },
                          (v75/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v45/*: any*/),
                              (v68/*: any*/),
                              (v30/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          (v97/*: any*/),
                          (v64/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v52/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bd88bdfcd43fa366fbdcbe89d654db93fd30d591bc0f038b7733d40959af80ed",
    "metadata": {},
    "name": "AggGoalTabContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "eec661d695f7e23613f4153a9d499384";

export default node;
